export default __webpack_public_path__ + "static/media/opencv.0f128460.svg";